import { handleActions } from 'modules/helpers';

import { ActionTypes } from 'constants/index';

export const appState = {
  suggestions: {
    brands: [],
    accounts: [],
    locations: [],
    cities: [],
    contacts: [],
  },
  loading: false,
};

const EMPTY_SUGGESTIONS = {
  brands: [],
  accounts: [],
  locations: [],
  cities: [],
  contacts: [],
};

export default {
  search: handleActions(
    {
      [ActionTypes.GET_SEARCH_SUGGESTIONS]: draft => {
        draft.loading = true;
      },
      [ActionTypes.GET_SEARCH_SUGGESTIONS_SUCCESS]: (draft, { payload }) => {
        draft.suggestions = {
          brands: (payload && payload.brands) || [],
          accounts: (payload && payload.accounts) || [],
          locations: (payload && payload.locations) || [],
          cities: (payload && payload.cities) || [],
          contacts: (payload && payload.contacts) || [],
        };
        draft.loading = false;
      },
      [ActionTypes.GET_SEARCH_SUGGESTIONS_FAILURE]: draft => {
        draft.loading = false;
      },
      [ActionTypes.CLEAR_SEARCH_SUGGESTIONS]: draft => {
        draft.suggestions = { ...EMPTY_SUGGESTIONS };
        draft.loading = false;
      },
    },
    appState,
  ),
};
